import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Notification from '../Notification/Notification';
import Footer from "../../components/Footer/Footer.jsx";
import dashboardRoutes from "../../routes/dashboard.jsx";
import Header from "../../components/Header/Header.jsx";
import Sidebar from "../../components/Sidebar/Sidebar.jsx";

class Dashboard extends Component {
  constructor(props) {
    super(props);

  }

  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }

    // if (e.history.action === "PUSH") {
    //   document.documentElement.scrollTop = 0;
    //   document.scrollingElement.scrollTop = 0;
    //   this.mainPanel.scrollTop = 0;
    // }
  }
  render() {
    return (
      <div className="wrapper">
      <Notification/>
      <Sidebar {...this.props}/>
        <div id="main-panel" className="main-panel" ref={this.mainPanel}>
          <Header {...this.props} />
          <Switch>
            {dashboardRoutes.map((prop, key) => {
              if (prop.name === "Notifications")
                return (
                  <Route
                    path={prop.path}
                    key={key}
                    component={prop.component}
                  />
                );
              if (prop.redirect)
                return <Redirect from={prop.path} to={prop.to} key={key} />;
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
          <Footer />
        </div>
      </div>
    );
  }
}

export default Dashboard;
